import React, { FC, useState, useEffect, PropsWithChildren } from 'react';

import Mobile from '../../pages/Mobile';

const MobileDetect: FC<PropsWithChildren> = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (window.innerWidth <= 640) {
      setIsMobile(true);
    }
  }, []);

  return isMobile ? <Mobile /> : <React.Fragment>{children}</React.Fragment>;
};

export default MobileDetect;
